// All Cloudflare Worker API calls flow through workerFetch.
// getWorkerBase   — resolves the configured worker URL
// workerFetch     — adds 8s timeout, injects bearer token, checks res.ok
// fetchSheet      — convenience alias for /api/sheet?tab=X

export const AUTH_TOKEN_KEY  = 'meridian_auth_token';
export const QUIVER_KEY      = 'meridian_quiver_key';
export const ETHERSCAN_KEY   = 'meridian_etherscan_key';
export const WHALE_ALERT_KEY = 'meridian_whale_alert_key';

const WORKER_DEFAULT = 'https://twilight-dew-3ae7.delfrost42.workers.dev';

export function getWorkerBase(): string {
  return new URLSearchParams(window.location.search).get('worker')
    ?? localStorage.getItem('meridian_worker_url')
    ?? WORKER_DEFAULT;
}

export async function workerFetch<T = unknown>(
  path: string,
  opts: RequestInit = {},
): Promise<T> {
  const base = getWorkerBase();
  if (!base) throw new Error('Worker URL not configured — set meridian_worker_url in Settings');

  // Inject bearer token when configured
  const token = localStorage.getItem(AUTH_TOKEN_KEY);
  const authHeaders: Record<string, string> = token ? { 'Authorization': `Bearer ${token}` } : {};

  const res = await fetch(base + path, {
    signal: AbortSignal.timeout(8000),
    ...opts,
    headers: { ...authHeaders, ...(opts.headers as Record<string, string> ?? {}) },
  });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.json() as Promise<T>;
}

export interface SheetResponse<R = Record<string, string>> {
  status: 'ok' | 'error';
  rows?: R[];
  message?: string;
}

export function fetchSheet<R = Record<string, string>>(tab: string): Promise<SheetResponse<R>> {
  return workerFetch<SheetResponse<R>>(`/api/sheet?tab=${encodeURIComponent(tab)}`);
}
